<template>
    <div class="modal fade show"  id="staticBackdrop"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-modal="true" role="dialog"
      style="display:block; background-color:rgba(255, 255, 255, 0.6);" >
        <div class="modal-dialog modal-dialog-centered">

          <div class="modal-content" style="overflow-x: hidden;">
            <div class="modal-header">
              <h5 class="modal-title"></h5>
              <h5 class="fw-bold mb-0">운행집계상세</h5>
              <button type="button" class="btn-close" @click="$emit('close-modal')"/>
            </div>

            <form v-on:submit.prevent>
              <div class="row row-cols-auto ms-3 mb-2 ">
                <div class="col">
                  <label for="selectEmployeeId" class="form-label">결제타입</label>
                  <kona-select class="form-select w-150" :options="typeList" :key="renderkey"
                              @change="changeFormValue($event, 'type')"></kona-select>
                </div>
                <div class="col">
                  <label class="form-label">&nbsp;</label>
                  <br>
                  <button class="btn btn-primary shadow-sm refresh-btn" @click="clickRefreshBtn" type="button">
                    <BIconArrowCounterclockwise/>
                  </button>
                  <button class="btn btn-primary shadow-sm search-btn" @click="clickSearchBtn" type="button">
                    <BIconSearch/>&nbsp;조회
                  </button>
                </div>

                <div class="inner-top">
                  <div class="permission-group-info" :class="readOnly?'readOnly':''">
                    <table class="group-info-table border-bottom border-top">
                      <tbody>
                        <tr>
                          <th>출근시간</th>
                          <th>퇴근시간</th>
                        </tr>
                        <tr>
                          <td>{{ changeFormat(param.startDate, 'YYYY-MM-DD HH:mm:ss') }}</td>
                          <td>{{ changeFormat(param.endDate, 'YYYY-MM-DD HH:mm:ss') }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
              <div class="mb-5"  v-if="!readOnly" style="padding:1rem;">
              <p style="margin-bottom:02rem; font-size:0.8rem; font-weight:600;">결제타입별 내역</p>
                <DrivingAggregateSummaryTable class="max-50" :fields="drivingAggregateSummaryDtoFields"
                                              :elements="drivingAggregateSummaryDtoElements" ref="summaryDataTableRef"/>
              </div>
            </form>

            <div class="permission-group-info" :class="readOnly?'readOnly':''">
              <VueDataTable
                  :columns="dtColsRef"
                  :data="dtDataRef"
                  :options="dtOptions"
                  :exportOptions="dtExportOpts"
                  ref="vDtRef"
              >
                <template #header-left>
                  <RowsCt :ct="dtDataRef.length"/>
                </template>
              </VueDataTable>
            </div>
            <div style="text-align: right; margin: 1rem;">
              <button type="button" class="btn btn-primary shadow-sm close-btn" @click="$emit('close-modal')">닫기</button>
            </div>
          </div>
        </div>
      </div>
  </template>

  <script setup>
  import {defineEmits, defineProps, onMounted, ref} from 'vue'
  import {useStore} from "vuex";
  import Entity from '@/entity/OperationEntity'
  import tachoEntity from "@/entity/TachoEntity";
  import axios from "@/composables/Axios";
  import {DrivingAggregateSummaryTable} from "@/components/tacho/component";
  import {BIconArrowCounterclockwise, BIconSearch} from "bootstrap-icons-vue";
  import commonService from "@/components/tacho/common/CommonService";
  import excelEntity from "@/entity/ExcelEntity";
  import {changeFormat, insertComma, viewYN} from '@/components/tacho/common/CommonFunc';
  import VueDataTable from "@/components/tacho/component/VueDataTable.vue";
  import RowsCt from "@/components/tacho/component/vue-datatable/RowsCt.vue";

  const store = useStore(),
    url = store.state['api'].operationUrl,
    setLoading = (value) => store.commit('setLoading', value);

const userId = store.state.sign['userInfo'].userId;
const entity = new Entity.organizationHeaders(userId);

const props = defineProps({
  parentOrganizationOption: Array,
  param: Object,
  readOnly: Boolean
})

const param = ref(JSON.parse(JSON.stringify(props.param)));
let viewYn = store.state.sign['userInfo'].viewYN
param.value.viewYn = viewYN(viewYn);
const emit = defineEmits(['close-modal']);

let queryParam = new tachoEntity.drivingSearchDto();
const drivingAggregateSummaryDto = new tachoEntity.drivingAggregateSummaryDto();
let drivingAggregateSummaryDtoFields = drivingAggregateSummaryDto.fields();
let drivingAggregateSummaryDtoElements = ref([]);
const drivingAggregateDetailDto = new tachoEntity.drivingAggregateDetailDto();
let drivingAggregateDetailDtoFields = drivingAggregateDetailDto.fields();

drivingAggregateDetailDtoFields = [{ key:"no", label:"No." }, ...drivingAggregateDetailDtoFields]

let typeList = ["전체", ...Object.values(tachoEntity.paymentTypeEnum)];
typeList = typeList.splice(0, typeList.length - 2);

let payType = '';
let companyName = ref('');

const renderkey = ref(0);
const clickRefreshBtn = ()=>{
  typeList = ["전체", ...Object.values(tachoEntity.paymentTypeEnum)];
  typeList = typeList.splice(0, typeList.length - 2);
  payType="";
  renderkey.value++;
}

const columnDefList = [
  {
    targets: [1],
    class: "text-center",
    visible: false
  },
  {
    targets: [4, 5, 14],
    class: "text-center",
    render:
        function (data, type, row, meta) {
          return changeFormat(data, 'YYYY-MM-DD HH:mm:ss');
        },
  },
  {
    targets: [7,8,9,10,11,12],
    class: "text-center",
    render:
        function (data, type, row, meta) {
          return insertComma(data);
        },
  },
];

onMounted(async() => {
  companyName.value = param.value.companyName

  queryParam = {
    officeId: param.value.officeId,
    carNum: param.value.carNum,
    driverId: param.value.driverId,
    startDate: param.value.startDate,
    endDate: param.value.endDate,
    payType: payType,
    viewYn: param.value.viewYn
  }

  await getDrivingAggregateSummaryDto(queryParam);
})

function transformTripParams(queryParam) {
  return {
    fromDtti: queryParam.startDate,
    untilDtti: queryParam.endDate,
    officeId: queryParam.officeId,
    carNum: queryParam.carNum,
    driverId: queryParam.driverId,
    payType: queryParam.payType,
  };
}

const getDrivingAggregateSummaryDto = async (queryParam, page = 1, size = 3000) => {
  try {
    setLoading(true);

    const tripParams = transformTripParams(queryParam);
    const summary = axios.$get(`${url}trips/details/summary`, {params: tripParams}, entity.get());

    summary.then((response) => {
      drivingAggregateSummaryDtoElements.value = response.data.data.map(v => new tachoEntity.drivingAggregateSummaryDto().fromMap(v));
      const sum = new tachoEntity.drivingAggregateSummaryDto(99, 0, 0, 0, 0, 0);
      sum.add(response.data.data);
      drivingAggregateSummaryDtoElements.value.push(sum);
    });

    await summary;

    let isLast = false;
    let resList = [];
    while(!isLast) {
      let res = axios.$get(`${url}trips/details?page=${page - 1}&size=${size}`, {params: tripParams}, entity.get());
      res.then((response) => {
        isLast = response.data.data.last;
        resList = [...resList, ...response.data.data.content];
      });
      await res;

      page++;
    }

    dtDataRef.value = resList.map(v => new tachoEntity.drivingAggregateDetailDto().fromMap(v));
  } catch (err) {
    setLoading(false);
    store.commit("openMessageBox", err);
  } finally {
    setLoading(false);
  }
}

const changeFormValue = async (event, name) => {
  switch (name) {
    case "type": {
      event.target.value === "전체" ? payType = "" : payType = tachoEntity.getKeyByValue(tachoEntity.paymentTypeEnum, event.target.value);
      break;
    }
  }
}

const clickSearchBtn = async () => {
  // setting queryParam
  queryParam = {
    officeId: param.value.officeId,
    carNum: param.value.carNum,
    driverId: param.value.driverId,
    startDate: param.value.startDate,
    endDate: param.value.endDate,
    payType: payType
  }

  getDrivingAggregateSummaryDto(queryParam);
}

const vDtRef = ref(null);
const dtColsRef = ref([
  {
    field: "carNum",
    header: "차량번호",
  },
  {
    field: "driverId",
    header: "사원번호",
  },
  {
    field: "minDttiDisplay",
    sortField: "minDtti",
    header: "운행시작",
  },
  {
    field: "maxDttiDisplay",
    sortField: "maxDtti",
    header: "운행종료",
  },
  {
    field: "workTime",
    header: "운행시간",
  },
  {
    field: "workDist",
    header: "운행거리 (KM)",
  },
  {
    field: "payFareDisplay",
    sortField: "payFare",
    header: "미터금액 (원)",
  },
  {
    field: "callFareDisplay",
    sortField: "callFare",
    header: "호출요금 (원)",
  },
  {
    field: "hipassFareDisplay",
    sortField: "hipassFare",
    header: "통행요금 (원)",
  },
  {
    field: "addFareDisplay",
    sortField: "addFare",
    header: "추가금액 (원)",
  },
  {
    field: "fareDisplay",
    sortField: "fare",
    header: "합계금액 (원)",
  },
  {
    field: "payType",
    header: "결제타입",
  },
  {
    field: "payDtti",
    header: "결제시간",
  },
]);
const dtDataRef = ref([]);
const dtOptions = {
  sortField: 'minDtti',
  sortOrder: 1,
};
const dtExportOpts = [
  {
    id: 'excelDefault',
    name: '기본(엑셀)',
    exportFn: ({jqueryOrderData}) => {
      const fileName = '운행집계상세';
      const titles = new excelEntity.aggregateDetailExcelEntity().fields().map(v => v.label);
      const tripParams = transformTripParams(queryParam);
      return commonService.excelDrivingAggregateDetail(
          `${url}trips/details`,
          tripParams,
          companyName.value,
          fileName,
          titles,
          entity.get(),
          new excelEntity.aggregateDetailExcelEntity(),
          '',
          '',
          '',
          jqueryOrderData,
      );
    }
  },
];
</script>

  <style scoped>
  .modal-dialog {
      font-size: 0.8rem;
      min-width: 60rem;
  }
  .inner-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .inner-top button{
    border: none;
    padding: 0.25rem 2rem;
    margin: 5px;
    font-size: 13px;
    color: #ffffff;
    background-color: #000000;
  }
  .inner-top,
  .permission-group-info{
    padding: 10px;
  }
  /* .permission-group-info{
    margin: 0 0  1.5rem 0;
  } */
  .permission-group-info.readOnly{
    padding: 0 0 1rem 0;
    margin: 0 0  1.5rem 0;
  }
  .group-info-table th,
  .group-info-table td{
    text-align: center;
    padding: 0.4rem 0.5rem !important;
  }
  .group-info-table th{
    background-color: #e3e3e3;
    width: 10rem;
  }
  .group-info-table td{
    width: 15rem;
  }
  .group-info-table td input,
  .group-info-table td select{
    font-size: 13px;
  }
  .operation-bottom{
    padding: 10px;
  }

  .operation-bottom-inner{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .operation-bottom-inner button{
    border: none;
    padding: 0.25rem 2rem;
    margin: 5px;
    font-size: 13px;
    color: #ffffff;
    background-color: #000000;
  }

  /* 라디오 버튼 */
  .radioDiv{
    display: inline-block;
    margin-right: 10px;
  }
  .radioDiv input{
    margin-right: 3px;
  }

  /* 이메일란 */
  .emailDiv{
    display: flex
  }
  .emailDiv > button {
    border: none;
    padding: 0.25rem 0.25rem;
    margin-left: 5px;
    font-size: 13px;
    color: #ffffff;
    background-color: #000000;
  }
  .modal-content{
    width: 200% !important
  }

  .close-btn{
    background-color: #cccccc;
    width: 5rem;
  }
  </style>
